import { render, staticRenderFns } from "./smsChart.vue?vue&type=template&id=12f05b0a&scoped=true"
import script from "./smsChart.vue?vue&type=script&lang=js"
export * from "./smsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f05b0a",
  null
  
)

export default component.exports